<template>
    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이벤트 이름(행사명)" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="eventNmRef" v-model="state.eventParams.event_nm" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              
              <ElLabel name="일시" :required="true">
                <template #end="{id}">
                  <div class="d-flex justify-content-between">
                    <DatePicker ref="eventDtRef" :select-date="state.eventParams.event_dt"  @return="r => state.eventParams.event_dt = r" disabled/>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="장소" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="eventPlace" v-model="state.eventParams.event_place" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="목적">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.prpss" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="주관사" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="sponsor" v-model="state.eventParams.sponsor" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="발표자">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.prsnt" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="행사장 규모">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.event_scale" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="행사 증정품">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.gift" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="행사내용">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.event_dtls" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row band">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="클레임 비용">
                <template #end="{id}">
                  <ElInput :id="id"  :onlyNumber="true" v-model="state.eventParams.claim_cost" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="마케팅 펀딩사">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.mk_fund" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="클레임 처리방법">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.claim_mthd" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <!--todo : captionList 공통컴포넌트 적용-->
          
            <Caption
              ref="captionRef"
              :tbId="'event'"
              :cap_seq="state.eventParams.ev_seq"
              :readonly="true"
            />
          
        </div>
      </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      </div>
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              설문내용(첨부파일)
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <FileUpload ref="fileUploadRef" :can-update="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
  
  </template>
  
  <script setup>
  import { reactive, ref, onBeforeMount } from 'vue'
  import DatePicker from '@/components/common/DatePicker.vue';
  import Caption from '@/components/common/CaptionList.vue';
  import { useRouter } from "vue-router";
  import FileUpload from '@/components/common/FileUpload.vue';
  import routerCmn from '@/js/vueRouterCmn';
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { eventSelect } from '@/api/event';
  import { fileList } from '@/api/file';
  const router = useRouter();
  const fileUploadRef = ref()
  const eventNmRef = ref()
  const eventPlace = ref()
  const sponsor = ref()
  const excelUploadModalRef = ref();
  const captionRef = ref();
  const eventDtRef = ref()
  
  onBeforeMount(async () => {
    let ev_seq = history.state.ev_seq;
  
    if (ev_seq) {
      let param = {
        ev_seq: ev_seq
      }
      try {
        setIsLoading(true)
        const res = await eventSelect(param)
        let detailSm = res.rtn
  
        // 이벤트 이름 : event_nm
        // 일시 : event_dt
        // 장소 : event_place
        // 목적 : prpss
        // 주관사 : sponsor
        // 발표자 : prsnt
        // 행사장규모 : event_scale
        // 행사증정품 : gift
        // 행사내용 : event_dtls
        // 클레임비용 : claim_cost
        // 마케팅펀딩사 : mk_fund
        // 클레임처리방법 : claim_mthd
  
        state.eventParams.ev_seq = detailSm.ev_seq
        state.eventParams.event_nm = detailSm.event_nm
        state.eventParams.event_dt = detailSm.fmt_event_dt
        state.eventParams.event_place = detailSm.event_place
        state.eventParams.prpss = detailSm.prpss
        state.eventParams.sponsor = detailSm.sponsor
        state.eventParams.prsnt = detailSm.prsnt
        state.eventParams.event_scale = detailSm.event_scale
        state.eventParams.gift = detailSm.gift
        state.eventParams.event_dtls = detailSm.event_dtls
        numberMask(detailSm.claim_cost)
        state.eventParams.mk_fund = detailSm.mk_fund
        state.eventParams.claim_mthd = detailSm.claim_mthd
  
        //첨부파일이 존재할경우 파일리스트 조회api 호출
        if (detailSm.file_seq_grp != '' && detailSm.file_seq_grp != null && detailSm.file_seq_grp != undefined) {
          let apiParam = {
            file_seq_grp: detailSm.file_seq_grp
          }
          try {
            const resFileList = await fileList(apiParam)
            fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
          } catch (err) {
            console.log('파일리스트 조회 api 에러', err)
            alert('파일리스트 조회에 실패했습니다.')
            // routerCmn.routerPush('/sm/MSM_SA_008')
            throw err
          }
        }
      } catch (err) {
        console.log('이벤트 상세조회 api 에러', err)
        alert('이벤트 상세 조회에 실패했습니다.')
        routerCmn.routerPush('/sm/MSM_SA_007')
      } finally {
        setIsLoading(false)
      }
    }else{
      alert('잘못된 접근입니다.')
    }
  })
  

  
  const state = reactive({
    eventParams: {
      ev_seq: '',
      event_nm: '',
      event_dt: '',
      event_place: '',
      prpss: '',
      sponsor: '',
      prsnt: '',
      event_scale: '',
      gift: '',
      event_dtls: '',
      claim_cost: '0',
      mk_fund: '',
      claim_mthd: 0,
      tmp_yn: '',
      del_yn: 'N',            // 삭제여부
      cap_seq : 0,
      tb_id : 'event',
      attachFileVO: {
        file_div_id: '10',
        file_seq: '',         // 추가 된 파일 seq 전송
        del_file_seq: ''      // 삭제해야 할 파일 seq 전송
      }
    },
    //파일 첨부 데이터
    fileList: [],
    delFileList: [],
    excelModalColDefs: [
      { header: "이벤트 이름(행사명)", field: "event_nm", req: true, style: { minWidth: '100px' } },
      { header: "일시", field: "event_dt", req: true, style: { minWidth: '100px' },type:'date' },
      { header: "장소", field: "event_place", req: true, style: { minWidth: '100px' } },
      { header: "목적", field: "prpss", style: { minWidth: '100px' } },
      { header: "주관사", field: "sponsor", req: true, style: { minWidth: '100px' } },
      { header: "발표자", field: "prsnt", style: { minWidth: '100px' } },
      { header: "행사장 규모", field: "event_scale", style: { minWidth: '100px' } },
      { header: "행사 증정품", field: "gift", style: { minWidth: '100px' } },
      { header: "행사내용", field: "event_dtls", style: { minWidth: '100px' } },
      { header: "클레임 비용", field: "claim_cost", type: 'number', style: { minWidth: '100px' } },
      { header: "마케팅 펀딩사", field: "mk_fund", style: { minWidth: '100px' } },
      { header: "클레임 처리방법", field: "claim_mthd", style: { minWidth: '100px' } },
    ],
  
  })
  // 숫자형식 포맷 (10,000, 숫자만 들어갈 수 있도록)  
  const numberMask = (data) => {
    let len, point, str;
  
    data = data.replace(/[^0-9]/g, '');
    data = data.replace(/(^0+)/, '');
  
    point = data.length % 3;
    len = data.length;
    str = data.substring(0, point);
  
    while (point < len) {
      if (str != '') str += ',';
      str += data.substring(point, point + 3);
      point += 3;
    }
    // state.eventParams.claim_cost = common.checkNumberComma(data);
    state.eventParams.claim_cost = str;
  }
  

  
  const openModal = (modal) => {
    switch (modal) {
      case 'upload':
        excelUploadModalRef.value.openModal();
    }
  };
  </script>